/**
 * `findTextObserver` 알림이 찾기 bar 를 열어야 하는지 — 검색어가 있거나, 빈 검색어라도 `focus:true` 면 연다.
 * 빈 검색어 + `focus:true` 는 Kotlin desktop `ThreadViewWebComponent.findText("", true)`
 * (= `setFindText('', '{"focus":true}')`) 와 desktop host `openViewerFindBar` 가 bar 를 여는 NativeToWeb 계약이다.
 */
export const isFinderOpenRequest = (text: string | null, options?: { focus?: boolean }): boolean =>
  (text != null && text.length > 0) || options?.focus === true

/**
 * 찾기 bar 를 닫아야 하는지 — 빈 검색어 + `focus:false`. desktop host 는 메일이 바뀔 때마다 목록 검색어를
 * `focus:false` 로 다시 민다(`setViewerFindText`). 목록 검색이 없으면 그 값이 빈 문자열이라, provider 가
 * 재마운트되지 않는 전환(펼친 thread 의 부모→자식·자식→자식)에서도 bar 가 닫힌다. `focus` 가 없는
 * `notify('')`(bar 의 `closeFinder`)는 이미 닫는 중이라 해당하지 않는다.
 */
export const isFinderCloseRequest = (text: string | null, options?: { focus?: boolean }): boolean =>
  text === '' && options?.focus === false
